import ArrowMore from "graphics/icons/General/ArrowMore";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import ReactSwitch from "react-switch";
import {
  selectMembersLocked,
  selectMembersMuted,
  selectMembersShoutable,
  selectAdminControlsActive,
  setAdminControlsActive,
  selectMembersChatable,
} from "slices/spaceMediaSlice";
import {
  disableChatForMembers,
  disableShoutForMembers,
  enableChatForMembers,
  enableShoutForMembers,
  lockMembers,
  lockSpace,
  muteAllMembers,
  selectSpaceLocked,
  unlockMembers,
  unlockSpace,
  unmuteAllMembers,
} from "slices/spaceSlice";

const AdminControls = () => {
  const dispatch = useDispatch();
  const membersMuted = useSelector(selectMembersMuted);
  const membersShoutable = useSelector(selectMembersShoutable);
  const membersChatable = useSelector(selectMembersChatable);
  const membersLocked = useSelector(selectMembersLocked);
  const spaceLocked = useSelector(selectSpaceLocked);
  const adminControlsActive = useSelector(selectAdminControlsActive);

  return (
    <div
      className={`space-admin-controls ${
        adminControlsActive ? "expanded" : ""
      }`}
    >
      <button
        className="accordian-button"
        onClick={() => dispatch(setAdminControlsActive(!adminControlsActive))}
      >
        <div className={`dropper-arrow ${adminControlsActive ? "active" : ""}`}>
          <ArrowMore />
        </div>
        &nbsp;&nbsp; Admin Controls
      </button>
      {adminControlsActive && (
        <div className={`content`}>
          <div className="help-text">Only applies to non-admin occupants</div>
          <div className="row-section">
            <label>
              <span>Members Muted</span>
              <ReactSwitch
                height={25}
                handleDiameter={21}
                onChange={() =>
                  membersMuted ? unmuteAllMembers() : muteAllMembers()
                }
                checked={membersMuted}
              />
            </label>
          </div>
          <div className="row-section">
            <label>
              <span>Podium Disabled</span>
              <ReactSwitch
                height={25}
                handleDiameter={21}
                onChange={() =>
                  membersShoutable
                    ? disableShoutForMembers()
                    : enableShoutForMembers()
                }
                checked={!membersShoutable}
              />
            </label>
          </div>
          <div className="row-section">
            <label>
              <span>Chat Disabled</span>
              <ReactSwitch
                height={25}
                handleDiameter={21}
                onChange={() =>
                  membersChatable
                    ? disableChatForMembers()
                    : enableChatForMembers()
                }
                checked={!membersChatable}
              />
            </label>
          </div>
          <div className="row-section">
            <label>
              <span>Positions Locked</span>
              <ReactSwitch
                height={25}
                handleDiameter={21}
                onChange={() =>
                  membersLocked ? unlockMembers() : lockMembers()
                }
                checked={membersLocked}
              />
            </label>
          </div>
          {/* <button className="row-section"></button>
          //TODO - Form Into Groups, Invite Guests Into Space
          <button className="row-section"></button> */}
          <div className="row-section">
            <label>
              <span className="danger">Lock Space</span>
              <ReactSwitch
                height={25}
                handleDiameter={21}
                onChange={() => (spaceLocked ? unlockSpace() : lockSpace())}
                checked={spaceLocked}
                onColor="#ff3a3a"
              />
            </label>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminControls;
